export default __webpack_public_path__ + "static/media/carson-project-4.07b93020.webp";